import { prop } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import SelectField from 'Shared/form/SelectField';
import { assessmentManagerHomeRoute } from 'App/common/routeLookup';

const AssessmentManagerTCSelect = ({ categories }) => {
    const { setFieldValue } = useFormikContext();
    const { categoryId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        setFieldValue(
            'category',
            categories.find((cat) => cat.id === categoryId)
        );
    }, [categories, categoryId, setFieldValue]);

    return (
        <div style={{ minWidth: '30em' }}>
            <SelectField
                label="Select a therapeutic category"
                fieldName="category"
                options={categories}
                getOptionValue={prop('id')}
                getOptionLabel={prop('name')}
                onChange={(newVal) => {
                    navigate(generatePath(assessmentManagerHomeRoute, { categoryId: newVal.id }));
                }}
            />
        </div>
    );
};

AssessmentManagerTCSelect.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default AssessmentManagerTCSelect;
